import React, { Component } from 'react';
import Link from 'gatsby-link';

import { convertUnicode } from '../utils/string';

import './styles/Menu.scss';

class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayMenu: false,
    }
  }

  toggleHamburgerMenu() {
    const { displayMenu } = this.state;
    const toggleMenu = !displayMenu;

    this.setState({ displayMenu: toggleMenu });
  }

  hiddeHamburgerMenu() {
    this.setState({ displayMenu: false });
  }

  render() {
    const classDisplayMenu = this.state.displayMenu ? 'active' : '';
    const classDisplayTitle = this.state.displayMenu ? 'inactive' : '';

    const hamburgerSymbol = !this.state.displayMenu ? '&#x2630;' : ' 	&#9421;';

    return (
      <div className="header">
      <div
        className={`hamburger ${classDisplayMenu}`}
        onClick={ () => this.toggleHamburgerMenu() }
        dangerouslySetInnerHTML={{__html: hamburgerSymbol}} />
      <div
        className={`menu ${classDisplayMenu}`}
        onClick={ () => this.hiddeHamburgerMenu() }
      >
        <span className="menu-entry"><Link to="/">Accueil</Link></span>
        <span className="menu-entry"><Link to="/posts">Articles</Link></span>
        <span className="menu-entry"><Link to="/photos">Photos</Link></span>
        <span className="menu-entry"><Link to="/videos">Vidéos</Link></span>
        <span className="menu-entry"><Link to="/search">Recherche</Link></span>
        {/* <span className="menu-entry"><Link to="/about">About</Link></span> */}
      </div>
      <div className={`menu-blog--title ${classDisplayTitle}`}>
        <Link to="/">Le voyage de Big Boy</Link>
      </div>
    </div>
    );
  }
}

export default Menu;

{/* <span className="menu-entry menu-entry-dropdown">
  Dropdown menu
  <div className="menu-subentries">
    <span className="menu-subentry"><Link to="/search">Dropdown menu 1</Link></span>
    <span className="menu-subentry"><Link to="/search">Dropdown menu 2</Link></span>
    <span className="menu-subentry"><Link to="/search">Dropdown menu 3</Link></span>
  </div>
</span> */}


// WEBPACK FOOTER //
// ./src/components/Menu.jsx